<div (click)="onWrapperClick($event, errorMessage, duration)" class="wrapper">
    <a
        *ngIf="linkTarget && !isExternalLink"
        class="button"
        [ngClass]="['button--' + buttonColor, identifier]"
        [class.button--ghost]="isGhost"
        [class.button--green]="greenTheme"
        [class.button--has-arrow]="useArrow"
        [class._is_loading]="isLoading"
        [class._is_shaking]="shakeIt"
        (click)="onButtonClick($event)"
        [routerLink]="linkTarget | localized_url"
        [target]="target"
        [attr.download]="download ? download : null"
        [class._is_disabled]="disabled || isLoading"
    >
        <ng-container *ngTemplateOutlet="contentTmpl"></ng-container>
    </a>
    <a
        *ngIf="linkTarget && isExternalLink"
        class="button"
        [ngClass]="['button--' + buttonColor, identifier]"
        [class.button--ghost]="isGhost"
        [class.button--green]="greenTheme"
        [class.button--yellow]="yellowTheme"
        [class.button--has-arrow]="useArrow"
        [class._is_loading]="isLoading"
        [class._is_shaking]="shakeIt"
        (click)="onButtonClick($event)"
        [href]="linkTarget"
        [target]="target"
        [attr.download]="download ? download : null"
        [class._is_disabled]="disabled || isLoading"
        [rel]="target === '_blank' ? 'noopener' : null"
    >
        <ng-container *ngTemplateOutlet="contentTmpl"></ng-container>
    </a>
    <button
        *ngIf="!linkTarget"
        class="button"
        [ngClass]="['button--' + buttonColor, identifier]"
        [class.button--ghost]="isGhost"
        [class.button--green]="greenTheme"
        [class.button--yellow]="yellowTheme"
        [class.button--has-arrow]="useArrow"
        [class._is_loading]="isLoading"
        [class._is_shaking]="shakeIt"
        [type]="type"
        [disabled]="disabled || isLoading"
        (click)="onButtonClick($event)"
    >
        <ng-container *ngTemplateOutlet="contentTmpl"></ng-container>
    </button>
</div>

<ng-template #contentTmpl>
    <mat-progress-spinner *ngIf="isLoading" mode="indeterminate"></mat-progress-spinner>
    <span class="button__text">
        <ng-content></ng-content>
    </span>
</ng-template>
